'use client';

import { MAX_SPOT_MARKETS_PER_USER } from 'src/constants/markets';
import useAccountData from './useAccountData';
import { matchEnum } from '@drift/common';
import { MarketType } from '@drift-labs/sdk';
import { AccountData } from 'src/stores/useDriftAccountsStore';
import {
	useCurrentAccountOrders,
	useOrdersByUserKey,
} from './query/accountTradingData/useOrders';

const DEFAULT_ARRAY: number[] = [];

export const useExceedsMaxSpotBalance = (
	spotMarketIndexToAdd: number | undefined,
	targetAccountData?: AccountData | undefined
) => {
	const currentAccount = useAccountData();
	const targetAccount = targetAccountData ?? currentAccount;

	const currentOrders = useCurrentAccountOrders();
	const { data: targetOrders } = useOrdersByUserKey(targetAccountData?.userKey);
	const openOrders = targetAccountData
		? targetOrders?.openOrders
		: currentOrders;

	if (!spotMarketIndexToAdd) {
		return false;
	}
	const spotBalancesMarketIndices =
		targetAccount?.spotBalances.map((balance) => balance.asset.marketIndex) ??
		DEFAULT_ARRAY;
	const openSpotOrdersMarketIndices =
		openOrders
			?.filter((order) => matchEnum(order.marketIndex, MarketType.SPOT))
			.map((order) => order.marketIndex) ?? DEFAULT_ARRAY;

	const futureSpotMarketIndices = Array.from(
		new Set([
			...spotBalancesMarketIndices,
			...openSpotOrdersMarketIndices,
			spotMarketIndexToAdd,
		])
	);

	return futureSpotMarketIndices.length > MAX_SPOT_MARKETS_PER_USER;
};
